import {ReactComponent as AchievementSvg} from '../../../assets/img/svgs/achievements_dark.svg';
import {ReactComponent as ShippingSvg} from '../../../assets/img/svgs/shipping_dark.svg';
import {ReactComponent as TagSvg} from '../../../assets/img/svgs/tag_dark.svg';
import {ReactComponent as PaymentSvg} from '../../../assets/img/svgs/payment.svg';


const MobileFooter = () => {

  return (
    <div className="w-full app-top-mg app-side-pd bg-none flex pb-5">
      {footerItems.map((item) => <FooterItem {...item}/>)}
    </div>
  );
};

const FooterItem = ({title, subTitle, component, ...props}) => {
  return (
    <div className="flex flex-col items-center justify-center flex-1" {...props}>
      <div className="text-center pb-2">{component}</div>
      <div className="text-center text-sm text-rand-100">{title}</div>
      <div className="text-center text-xxs text-rand-100 leading-none font-light">{subTitle}</div>
    </div>
  );
};

export default MobileFooter;

const footerItems = [
  {
    title: "Payment Options",
    subTitle: "Safe and secure payments",
    component: <PaymentSvg height={36} fill="var(--color-secondary)"/>,
    key: "footer-item-free"
  },
  {
    title: "Genuine Products",
    subTitle: "100% authentic",
    component: <AchievementSvg height={36} fill="var(--color-secondary)"/>,
    key: "footer-item-genuine"
  },  
  {title: "1500 Brands", subTitle: "3Lakhs+ Products", component: <TagSvg height={36} fill="var(--color-secondary)"/>, key: "footer-item-brands"}
];